(function () {
  class FirelinkFeature extends PIXI.Container {
    constructor() {
      super();

      this._reels = [];
      this._stormLinkReels = [];
      this._freeSpinsReels = [];
      this._reelPrizeObjects = [];
      this._inFS = false;
      this._currentSpinPositions = [];
      this._currentBaseGameSymbols = [];
      this._prizes = [];
      this._active = false;

      this._fireBallIntro = undefined;
      this._fireballLinkStartData = undefined;
      this._fireballLinkStartTask = undefined;
      this._endEvent = undefined;

      this._skipped = false;

      this._reelsTimer = undefined;

      this._particleEmitter = undefined;

      this._endTaskWinnings = 0;

      this._maxWinBreached = false;

      this._megaPotValue = 0;
      this._megaPotWon = false;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "8bof:FireballLinkStartEvent",
        this.onfireballLinkStartEvent.bind(this)
      );
      messageBus.subscribe(
        "8bof:FireballLinkDataEvent",
        this.onfireballLinkDataEvent.bind(this)
      );
      messageBus.subscribe(
        "8bof:FireballLinkDataEventDead",
        this.onfireballLinkDataEventDead.bind(this)
      );
      messageBus.subscribe(
        "8bof:FireballLinkEndEvent",
        this.onfireballLinkEndEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsStartEvent",
        this.onFreespinsStart.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsEndEvent",
        this.onFreespinsEndEvent.bind(this)
      );
      messageBus.subscribe("spinner:SpinEvent", this.onSpin.bind(this));
      messageBus.subscribe(
        "stake:stakeChanged",
        this.onStakeChanged.bind(this)
      );
      Reflex.registerEventHandler(
        "layoutChange",
        this.onOrientationChange.bind(this)
      );
    }

    onOrientationChange() {
      if (this._active) {
        if (this._logo) {
          this._logo.visible = false;
        }
        //this._winlinesTab.visible = false;
      }
    }

    onStakeChanged(stake) {
      if (stake === undefined) {
        return;
      }

      let goldenBetButton = resourceManager.get("goldenBetToggleButton");
      if (
        goldenBetButton !== undefined &&
        goldenBetButton._flags.showGoldenBetActive
      ) {
        stake = stake / 1.25;
      }
      this._megaPotValue = stake * 5000;
      this._maxWin = stake * 10000;
    }

    findChild(parent, name) {
      const child = parent.find(function (child) {
        return child.Props.ID === name;
      });
      return child;
    }

    onGameConfigEvent() {
      const self = this;

      this._slotMachine = resourceManager.getController("SlotMachine0_0");
      for (let reel = 0; reel < gameData.numReels; ++reel) {
        let rows = [];
        let freeSpinRows = [];
        let stormLinkRows = [];
        this._reelPrizeObjects.push([]);
        for (let row = 0; row < gameData.numRows; ++row) {
          const id = reel * gameData.numRows + row;
          const rv = resourceManager.get(
            "slotContainer:firelinkFeatureContainer:firelinkFeature:reel" + id
          );
          rv.reassignSlotMachine(this._slotMachine);
          rows.push(rv);

          const stormLinkReel = resourceManager.get(
            "slotContainer:firelinkFeatureContainer:firelinkFeature:reel" +
              id +
              ":symbol0:symbol:childContainer:fireballCashOverlay"
          );
          stormLinkRows.push(stormLinkReel);

          const freeSpinReel = resourceManager.get(
            "slotContainer:reelContainer:reel" +
              reel +
              ":symbol" +
              row +
              ":symbol_standard:childContainer:fireballCashOverlay"
          );
          freeSpinRows.push(freeSpinReel);

          const prizeContainer = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id
          );
          prizeContainer.visible = false;

          const value = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":value"
          );
          value.visible = false;

          const mini = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":mini"
          );
          mini.visible = false;

          const mini_double = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":mini_double"
          );
          mini_double.visible = false;

          const minor = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":minor"
          );
          minor.visible = false;

          const minor_double = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":minor_double"
          );
          minor_double.visible = false;

          const major = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":major"
          );
          major.visible = false;

          const major_double = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":major_double"
          );
          major_double.visible = false;

          const mega = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":mega"
          );
          mega.visible = false;

          const mega_double = resourceManager.get(
            "slotContainer:firelinkPrizes:firelinkPrize" + id + ":mega_double"
          );
          mega_double.visible = false;

          this._reelPrizeObjects[reel].push({
            container: prizeContainer,
            text: value,
            mini,
            minor,
            major,
            mega,
            mini_double,
            minor_double,
            major_double,
            mega_double,
          });
        }
        this._reels.push(rows);
        this._stormLinkReels.push(stormLinkRows);
        this._freeSpinsReels.push(freeSpinRows);
      }

      this._particleEmitter = particleManager.createEmitter(
        "coin_emitter",
        "slotContainer:firelinkPrizes:particleContainer",
        0,
        0,
        false
      );
      this._particleEmitter.particleEmitter.emit = false;

      const coinContainer = resourceManager.get(
        "slotContainer:firelinkPrizes:coinContainer"
      );
      this._coinGroup1 = [];
      this._coinGroup2 = [];
      this._coinGroups = [this._coinGroup1, this._coinGroup2];
      this._currentCoinGroup = 0;

      for (let i = 0; i < 8; i++) {
        const coin = new PIXI.Sprite.fromImage(
          ReflexLoader.rootResDir + "particles/rune/Rune_00000.png"
        );
        coinContainer.addChild(coin);
        coin.visible = false;

        if (i < 4) {
          this._coinGroup1.push(coin);
        } else {
          this._coinGroup2.push(coin);
        }
      }

      this._redWinline = resourceManager.createObject(
        "movie",
        "redWinline",
        "slotContainer:winlineContainer",
        {
          definition: "winlineAnim",
        }
      );
      this._redWinline.loop = false;
      this._redWinline.visible = false;
      this._redWinline.gotoAndStop(0);
      this._redWinline.onComplete = function () {
        self._redWinline.visible = false;
      };

      const filter = new PIXI.filters.ColorMatrixFilter();
      filter.hue(-85, false);
      this._redWinline.filters = [filter];

      this._slotMachine.selectReelMode("default");

      this._slotMachine.subscribeToReelsLandedEvent(function (reelId) {
        self.onSpinLand(reelId);
      });

      this._lives = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:lives"
      );

      this._livesTextLabel = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:livesText"
      );

      this._collectedText = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature:collected"
      );

      this._winningsPanel = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:moneyPanel"
      );
      this._winningsPanel.visible = false;
      this._winningsText = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:moneyPanel:winnings"
      );

      this._fireBallIntro = resourceManager.get(
        "slotContainer:fireballIntroPopup:fireballIntro"
      );

      this._linkBG = resourceManager.get(
        "baseGameBackground:landscapeBackground:mountainsFreeSpins"
      );
      this._linkBG.visible = false;

      this._linkBGPortrait = resourceManager.get(
        "baseGameBackground:portraitBackground:mountainsFreeSpins"
      );
      this._linkBGPortrait.visible = false;

      // this._winlinesTab = resourceManager.get(
      //   "slotContainer:reelFrame:winlinesTab"
      // );

      this._volcanoPot = resourceManager.get("hammerPotContainer");

      this._fireslotsManager = resourceManager.get(
        "slotContainer:freespinsFireSlots:fireslotManager"
      );

      this._shaker = resourceManager.get("reelsShaker");

      this._fireballLandAnimator = resourceManager.get(
        "slotContainer:FireballLandAnimator"
      );

      this._megaValue = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:megaValue"
      );
      this._megaValue.visible = false;

      this.visible = false;
    }

    onSpinLand(reelText) {
      let slotCount = +reelText.replace("reel", "");

      // play landing sound - this is quiet against the theme music
      let soundIndex = Math.floor(Math.random() * 8);
      soundManager.play("stormLinkreelStop" + soundIndex);

      // if reel that has landed is in the _newLockedReels array
      if (this._newLockedReels.includes(slotCount)) {
        // convert reel to reel/row
        let reel = Math.trunc(slotCount / gameData.numRows);
        let row = slotCount % gameData.numRows;

        this._reels[reel][row].bounceOverlays();

        let soundIndex = Math.floor(
          Math.random() * gameController.thunderballLandSound.length
        );

        const symbolInfo = resourceManager.getConfiguration().symbols;
        const symbolId = this._currentBaseGameSymbols[reel][row];

        if (symbolId === symbolInfo["Symbol_FireballX2"].ID) {
          soundManager.play("thunderballLandRed");
        } else {
          soundManager.play(gameController.thunderballLandSound[soundIndex]);
        }
      }
    }

    onSpin(task) {
      this._currentBaseGameSymbols = [];
      this._isWildFire = task.data.isWildFire;
      for (let reel = 0; reel < task.data.resultPanel.reelList.length; reel++) {
        this._currentBaseGameSymbols.push([]);
        for (
          let row = 0;
          row < task.data.resultPanel.reelList[reel].symbols.length;
          row++
        ) {
          this._currentBaseGameSymbols[reel].push(
            task.data.resultPanel.reelList[reel].symbols[row].value
          );
        }
      }
    }

    getNextSpinOutcome() {
      messageBus.post("spinner:stormLink");
      this._livesRemaining--;

      if (this._livesRemaining < 0) {
        messageBus.post("spinner:stormLinkEnd");
      }

      let livesVisible = this._livesRemaining > 0 ? true : false;

      this._livesTextLabel.visible = livesVisible;
      this._lives.visible = livesVisible;

      this._livesTextLabel.setTranslationPhrase(
        this._livesRemaining === 1 ? "t_live" : "t_lives"
      );

      this._lives.text = this._livesRemaining;

      if (this._livesRemaining >= 0) {
        soundManager.play("lifeDown");
      }

      gdk.getNextGameOutcome(function () {});
    }

    onfireballLinkStartEvent(task) {
      // set off the intro
      this._active = true;
      this._fireballLinkStartTask = task;
      this._fireballLinkStartTask.join();

      gameController.stormLinkSkip = true;

      this._fireballLinkStartData = task.data;

      this._linkBG.visible = true;
      this._linkBGPortrait.visible = true;

      gameController.buyABonusFireball = true;

      this._volcanoPot.visible = false;

      this._fireslotsManager.visible = false;
      this._fireslotsManager.setx2PanelAlpha(0);

      gameController.wildLandAnimator.skip();
      const symbols = resourceManager.getConfiguration().symbols;
      this._slotMachine.highlightSymbolIds([
        symbols["Symbol_Fireball20"].ID,
        symbols["Symbol_Fireball40"].ID,
        symbols["Symbol_Fireball60"].ID,
        symbols["Symbol_Fireball80"].ID,
        symbols["Symbol_Fireball100"].ID,
        symbols["Symbol_Fireball200"].ID,
        symbols["Symbol_Fireball300"].ID,
        symbols["Symbol_Fireball400"].ID,
        symbols["Symbol_Fireball500"].ID,
        symbols["Symbol_FireballMini"].ID,
        symbols["Symbol_FireballMinor"].ID,
        symbols["Symbol_FireballMajor"].ID,
        symbols["Symbol_FireballMega"].ID,

        symbols["Symbol_BlueFireball20"].ID,
        symbols["Symbol_BlueFireball40"].ID,
        symbols["Symbol_BlueFireball60"].ID,
        symbols["Symbol_BlueFireball80"].ID,
        symbols["Symbol_BlueFireball100"].ID,
        symbols["Symbol_BlueFireball200"].ID,
        symbols["Symbol_BlueFireball300"].ID,
        symbols["Symbol_BlueFireball400"].ID,
        symbols["Symbol_BlueFireball500"].ID,
        symbols["Symbol_BlueFireballMini"].ID,
        symbols["Symbol_BlueFireballMinor"].ID,
        symbols["Symbol_BlueFireballMajor"].ID,
        symbols["Symbol_BlueFireballMega"].ID,

        symbols["Symbol_FireballX2"].ID,
      ]);
      this._shaker.doShake(1500);
      this._fireBallIntro.showIntro(this.fireballLinkStartCallback.bind(this));
    }

    fireballLinkStartCallback() {
      messageBus.post("spinner:stormLink");

      this._fireballLinkStartTask.leave();

      resourceManager.getController("inputOverlord").setState("freespins");

      gameController.slotMachine.clearDimSymbolIds();

      this._livesTextLabel.visible = true;

      this._livesRemaining = this._fireballLinkStartData.livesRemaining;
      this._lives.text = this._livesRemaining;

      if (this._livesRemaining >= 0) {
        this._lives.visible = true;
      } else {
        this._lives.visible = false;
      }

      this._livesTextLabel.setTranslationPhrase(
        this._livesRemaining === 1 ? "t_live" : "t_lives"
      );

      this._fireballsCollected =
        this._fireballLinkStartData.startingFireballs.length;
      this._collectedText.setText(this._fireballsCollected);

      this._logo = resourceManager.get("baseGameLogo");
      this._logo.visible = false;

      this._fblLogo = resourceManager.get("slotContainer:stormLinkLogo");
      this._fblLogo.visible = true;

      this._18timeslogo = resourceManager.get("slotContainer:logo18times");
      this._18timeslogo.visible = true;

      this._winningsText.setText("0.00");

      this._lockedReels = [];
      this._newLockedReels = [];

      this._prizes = [];

      const symbolInfo = resourceManager.getConfiguration().symbols;
      //transfer base game symbols over to these reels
      for (let reel = 0; reel < gameData.numReels; reel++) {
        for (let row = 0; row < gameData.numRows; row++) {
          let symbolId = this._currentBaseGameSymbols[reel][row];
          if (
            this._isWildFire &&
            symbolId >= symbolInfo["Symbol_Fireball20"].ID &&
            symbolId <= symbolInfo["Symbol_FireballMega"].ID
          ) {
            const count = symbolId - symbolInfo["Symbol_Fireball20"].ID;
            symbolId = symbolInfo["Symbol_BlueFireball20"].ID + count;
            gameData.reels[reel].setReelSymbol(row, symbolId);
          }
          if (
            symbolId === symbolInfo["Symbol_SWild_x2"].ID ||
            symbolId === symbolInfo["Symbol_SWild_x3"].ID
          ) {
            symbolId = symbolInfo["Symbol_SWild"].ID;
          }
          this._reels[reel][row].setReelSymbol(0, symbolId);
        }
      }

      const self = this;
      this._fireballLinkStartData.startingFireballs.forEach(function (
        fireball
      ) {
        //self._reels[fireball.reel][fireball.row].setReelSymbol(0,fireball.symbolId);
        const id = fireball.reel * gameData.numRows + fireball.row;
        self._lockedReels.push(id);

        self._prizes.push({
          prizeData: fireball.prizeData,
          reel: fireball.reel,
          row: fireball.row,
          symbolId: fireball.symbolId,
        });
      });

      resourceManager.get("slotContainer:reelContainer").visible = false;
      this.visible = true;

      // slightly delay the first spin to give player the chance of seeing
      // initial number of respins otherwise it will have decremented straight away
      timerManager.addTimer(1000, undefined, function () {
        self.getNextSpinOutcome();
      });
    }

    processMultiSymbolWilds(reel, row, newSymbolId) {
      const symbolsInfo = resourceManager.getConfiguration().symbols;
      //if this fireball is going into a slot currently occupied by part of a x2 or 2x wild, we need to change the rest of that 2x or x3 wild
      const baseGameSymbolid = this._currentBaseGameSymbols[reel][row];
      if (baseGameSymbolid === symbolsInfo["Symbol_SWild_x2"].ID) {
        if (row === 0) {
          //if the x2 wild starts on the top row, we need to turn the row below into a x1 wild
          gameData.reels[reel].setReelSymbol(
            row + 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          this._currentBaseGameSymbols[reel][row + 1] =
            symbolsInfo["Symbol_SWild"].ID;
        } else if (row === 1) {
          //find out if the symbol above or below is the rest of the 2x wild and turn that one into a x1 wild
          if (
            this._currentBaseGameSymbols[reel][row - 1] ===
            symbolsInfo["Symbol_SWild_x2"].ID
          ) {
            gameData.reels[reel].setReelSymbol(
              row - 1,
              symbolsInfo["Symbol_SWild"].ID
            );
            this._currentBaseGameSymbols[reel][row - 1] =
              symbolsInfo["Symbol_SWild"].ID;
          } else {
            gameData.reels[reel].setReelSymbol(
              row + 1,
              symbolsInfo["Symbol_SWild"].ID
            );
            this._currentBaseGameSymbols[reel][row + 1] =
              symbolsInfo["Symbol_SWild"].ID;
          }
        } else {
          //if the x2 wild starts on the top row, we need to turn the row above into a x1 wild
          gameData.reels[reel].setReelSymbol(
            row - 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          this._currentBaseGameSymbols[reel][row - 1] =
            symbolsInfo["Symbol_SWild"].ID;
        }
      } else if (baseGameSymbolid === symbolsInfo["Symbol_SWild_x3"].ID) {
        if (row === 0) {
          gameData.reels[reel].setReelSymbol(
            row + 1,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          gameData.reels[reel].setReelSymbol(
            row + 2,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          this._currentBaseGameSymbols[reel][row + 1] =
            symbolsInfo["Symbol_SWild_x2"].ID;
          this._currentBaseGameSymbols[reel][row + 2] =
            symbolsInfo["Symbol_SWild_x2"].ID;
        } else if (row === 1) {
          gameData.reels[reel].setReelSymbol(
            row - 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          gameData.reels[reel].setReelSymbol(
            row + 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          this._currentBaseGameSymbols[reel][row - 1] =
            symbolsInfo["Symbol_SWild"].ID;
          this._currentBaseGameSymbols[reel][row + 1] =
            symbolsInfo["Symbol_SWild"].ID;
        } else {
          gameData.reels[reel].setReelSymbol(
            row - 1,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          gameData.reels[reel].setReelSymbol(
            row - 2,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          this._currentBaseGameSymbols[reel][row - 1] =
            symbolsInfo["Symbol_SWild_x2"].ID;
          this._currentBaseGameSymbols[reel][row - 2] =
            symbolsInfo["Symbol_SWild_x2"].ID;
        }
      }
      this._currentBaseGameSymbols[reel][row] = newSymbolId;
    }

    doSlamStop() {
      if (!this._active) return;

      let reelsToSlam = [];

      for (var i = 0; i < 18; i++) {
        reelsToSlam.push(i);
      }
      this._slotMachine.slamReels(reelsToSlam);

      if (this._reelsTimer !== undefined) {
        this._reelsTimer.remainingTime = 0;
      }
    }

    onfireballLinkDataEvent(task) {
      this._dataEvent = task;
      this._dataEvent.join();

      this._lockedReels.push(...this._newLockedReels);
      this._newLockedReels = [];
      this._slotMachine.holdReels(this._lockedReels);

      this._slotMachine.infiniteSpin();

      this._currentSpinPositions = [];

      const self = this;
      let aboveBelow = [];

      this._reels.forEach(function (reel) {
        reel.forEach(function (row) {
          aboveBelow.push([]);
          self._currentSpinPositions.push([0]);
        });
      });

      task.data.newFireballs.forEach(function (fireball) {
        const id = fireball.reel * gameData.numRows + fireball.row;

        self.processMultiSymbolWilds(
          fireball.reel,
          fireball.row,
          fireball.symbolId
        );

        gameData.reels[fireball.reel].setReelSymbol(
          fireball.row,
          fireball.symbolId
        );
        self._currentSpinPositions[id] = [fireball.symbolId];
        self._newLockedReels.push(id);

        self._prizes.push({
          prizeData: fireball.prizeData,
          reel: fireball.reel,
          row: fireball.row,
          symbolId: fireball.symbolId,
        });
      });

      // add fireballs collected
      this._fireballsCollected += task.data.newFireballs.length;

      task.data.blanks.forEach(function (blank) {
        const id = blank.coord.reel * gameData.numRows + blank.coord.row;
        self._currentSpinPositions[id] = [blank.symbol];
      });

      this._reelsTimer = timerManager.addTimeout(2000, function () {
        self._slotMachine.stopReels(
          self._currentSpinPositions,
          aboveBelow,
          aboveBelow,
          function () {
            self._livesRemaining = task.data.livesRemaining;

            let livesVisible = self._livesRemaining > 0 ? true : false;

            if (self._livesRemaining === 3) {
              soundManager.play("lifeReset");
              gameData.musicManager.increaseLevel("stormLink");
            }

            if (livesVisible) {
              self._lives.text = self._livesRemaining;
              self._lives.visible = true;
            } else {
              self._lives.visible = false;
            }

            self._livesTextLabel.visible = livesVisible;

            self._livesTextLabel.setTranslationPhrase(
              self._livesRemaining === 1 ? "t_live" : "t_lives"
            );

            timerManager.addTimeout(1000, function () {
              self._dataEvent.leave();
            });
          }
        );
      });
    }

    onfireballLinkDataEventDead(task) {
      messageBus.post("spinner:stormLinkEnd");

      this._collectedText.setText(this._fireballsCollected);
      if (task.newFireballs.length) {
        const self = this;
        timerManager.addTimer(
          500,
          function (progress) {
            const scale = InterpolationHelper.interpolateSine(
              1,
              1.25,
              progress
            );
            self._collectedText.scale.set(scale, scale);
          },
          function () {
            self._collectedText.scale.set(1, 1);
          }
        );
      }
      this.getNextSpinOutcome();
    }

    doFullFireballCelebration(callback) {
      soundManager.play("freeSpinsBonusWon");

      this._megaPotWon = true;

      let symbolsToAnimate = [];
      this._prizes.forEach(function (prize) {
        const reel = prize.reel * gameData.numRows + prize.row;
        symbolsToAnimate.push({
          cell: { reel, row: 0 },
          symbolId: prize.symbolId,
        });
      });

      const self = this;
      timerManager.addTimer(
        1000,
        function () {},
        function () {
          const x = layoutController.getCurrentPosition(
            self._megaValue.Props.FQN
          ).x;
          const y = layoutController.getCurrentPosition(
            self._megaValue.Props.FQN
          ).y;
          self._megaValue.position.set(x, y);
          self._megaValue.visible = false;
          self.countUpPrize(self._megaPotValue, function () {}, 1000);
        }
      );
      this._fireballLandAnimator.animateSymbols(
        symbolsToAnimate,
        this._slotMachine,
        true,
        true,
        function () {
          self._fireballLandAnimator.animateSymbols(
            symbolsToAnimate,
            self._slotMachine,
            true,
            true,
            function () {
              self._fireballLandAnimator.animateSymbols(
                symbolsToAnimate,
                self._slotMachine,
                true,
                true,
                function () {
                  callback();
                }
              );
            }
          );
        }
      );
    }

    processPrizes(callback) {
      this._multipliers = [];
      this._currentPrizeIndex = 0;

      gameData.musicManager.lowerFreeSpinsVolume();

      gameController.stormLinkPayout = true;

      if (this._fireballsCollected === gameData.numReels * gameData.numRows) {
        const self = this;
        this.doFullFireballCelebration(function () {
          self.sortPrizes();
          self.processNextPrize(callback);
        });
      } else {
        if (this._skipped) {
          this.sortPrizes();
          this.skipped(callback);
        } else {
          this.sortPrizes();
          this.processNextPrize(callback);
        }
      }
    }

    skip() {
      this._skipped = true;
    }

    skipped(callback) {
      let total = this._megaPotWon ? this._megaPotValue : 0;
      let multiplier = 1;

      for (let i = 0; i < this._prizes.length; i++) {
        let prize = this._prizes[i];
        let prizeType = prize.prizeData.type;

        if (
          prizeType === "Cash" ||
          prizeType === "WildCash" ||
          prizeType === "Pot" ||
          prizeType === "WildPot"
        ) {
          total += prize.prizeData.value;
        } else if (
          prizeType === "Multiplier" ||
          prizeType === "WildMultiplier"
        ) {
          multiplier *= prize.prizeData.value;
        }
      }

      this.countUpToNumber(total * multiplier, callback, 1000);

      soundManager.play("coinSplash");
    }

    getCurrentMaxWin() {
      if (gameController.inFirelink) {
        return this._maxWin - gameController.freespinsWinnings;
      } else {
        return this._maxWin;
      }
    }

    sortPrizes() {
      // we want to fire off prizes in order of left to right reels and top to bottom on each reel
      // this also handles multipliers - and they end up being stored in the multiplier array
      // in the same order left to right/top to bottom
      let tempPrizes = [];

      for (let reel = 0; reel < gameData.numReels; reel++) {
        for (let row = 0; row < gameData.numRows; row++) {
          // search for each reel/row and if found add to tempPrizes
          for (let i = 0; i < this._prizes.length; i++) {
            if (this._prizes[i].reel === reel && this._prizes[i].row === row) {
              tempPrizes.push(this._prizes[i]);
              break;
            }
          }
        }
      }

      this._prizes = JSON.parse(JSON.stringify(tempPrizes));

      //remove prizes past the max win
      let runningTotal = 0;
      if (this._fireballsCollected >= gameData.numReels * gameData.numRows) {
        runningTotal += this._megaPotValue;
      }
      let i = 0;
      for (; i < this._prizes.length; i++) {
        runningTotal += this._prizes[i].prizeData.value;
        if (runningTotal >= this.getCurrentMaxWin()) {
          break;
        }
      }
      this._prizes.splice(i + 1, this._prizes.length - (i - 1));
    }

    processNextPrize(callback) {
      if (this._skipped) {
        this.skipped(callback);
        return;
      }

      if (this._currentPrizeIndex < this._prizes.length) {
        let prizeType = this._prizes[this._currentPrizeIndex].prizeData.type;
        this.processPrize(
          this._prizes[this._currentPrizeIndex++],
          function () {}
        );

        // remove delay when we encounter a multiplier
        if (prizeType === "Multiplier" || prizeType === "WildMultiplier") {
          this.processNextPrize(callback);
        } else {
          const self = this;
          timerManager.addTimeout(800, function () {
            self.processNextPrize(callback);
          });
        }
      } else {
        callback();
      }
    }

    processPrize(prize, callback) {
      const reel = prize.reel;
      const row = prize.row;

      switch (prize.prizeData.type) {
        case "Cash":
        case "WildCash": {
          const text = this._reelPrizeObjects[reel][row].text;
          text.setText(gdk.formatCurrency(prize.prizeData.value));
          text.visible = true;
          const container = this._reelPrizeObjects[reel][row].container;

          this.toggleOverlay(false, reel, row);

          const self = this;
          this.collectPrize(container, reel, row, function () {
            self.toggleOverlay(true, reel, row);
            text.visible = false;
            self.countUpPrize(prize.prizeData.value, function () {
              callback();
            });
          });
          break;
        }
        case "Pot":
        case "WildPot": {
          this.processPotPrize(prize, callback);
          break;
        }
        case "Multiplier":
        case "WildMultiplier": {
          this._multipliers.push(prize);
          callback();
          break;
        }
      }
    }

    processPotPrize(prize, callback) {
      const reel = prize.reel;
      const row = prize.row;

      let sprite = undefined;
      let sprite_double = undefined;
      let pot = undefined;

      switch (prize.prizeData.potName) {
        case "Mini": {
          sprite = this._reelPrizeObjects[reel][row].mini;
          sprite_double = this._reelPrizeObjects[reel][row].mini_double;
          pot = resourceManager.get("potContainer:mini");
          break;
        }
        case "Minor": {
          sprite = this._reelPrizeObjects[reel][row].minor;
          sprite_double = this._reelPrizeObjects[reel][row].minor_double;
          pot = resourceManager.get("potContainer:minor");
          break;
        }
        case "Major": {
          sprite = this._reelPrizeObjects[reel][row].major;
          sprite_double = this._reelPrizeObjects[reel][row].major_double;
          pot = resourceManager.get("potContainer:major");
          break;
        }
        case "Mega": {
          sprite = this._reelPrizeObjects[reel][row].mega;
          sprite_double = this._reelPrizeObjects[reel][row].mega_double;
          pot = resourceManager.get("potContainer:mega");
          break;
        }
      }

      sprite.visible = true;

      // bounce pot value on pot panel
      timerManager.addTimer(
        250,
        function (progress) {
          let newScale = 1 + 0.3 * Math.abs(Math.sin(Math.PI * progress));
          pot.scale.set(newScale, newScale);
        },
        function () {
          pot.scale.set(1, 1);
        }
      );

      if (prize.prizeData.isDoubled) {
        sprite.position.setY(sprite.position.getY() - 25);
        sprite_double.visible = true;
      }

      const container = this._reelPrizeObjects[reel][row].container;

      this.toggleOverlay(false, reel, row);

      const self = this;
      this.collectPrize(container, reel, row, function () {
        self.toggleOverlay(true, reel, row);
        sprite.visible = false;
        if (prize.prizeData.isDoubled) {
          sprite.position.setY(sprite.position.getY() + 25);
          sprite_double.visible = false;
        }
        self.countUpPrize(prize.prizeData.value, callback);
      });
    }

    /**
     * Returns a random integer between min (inclusive) and max (inclusive).
     * The value is no lower than min (or the next integer greater than min
     * if min isn't an integer) and no greater than max (or the next integer
     * lower than max if max isn't an integer).
     */
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    animateCoins(startPos, endPos, duration) {
      const group = this._coinGroups[this._currentCoinGroup];

      for (let i = 0; i < group.length; i++) {
        const coin = group[i];
        const xx = this.getRandomInt(-20, 20);
        const yy = this.getRandomInt(-25, -15);
        const rotation = this.getRandomInt(0, 10);

        coin.visible = true;
        coin.scale.set(0.5, 0.5);
        coin.rotation = rotation;
        coin.position.set(startPos.x + xx, startPos.y + yy);
        coin.alpha = 0;

        gsap
          .timeline()
          .to(coin, {
            duration: 0.2,
            alpha: 1,
          })
          .to(
            coin,
            {
              duration,
              delay: i / 20,
              pixi: { scaleX: 0, scaleY: 0 },
              ease: "power3.in",
            },
            "<"
          )
          .to(
            coin,
            {
              duration,
              delay: i / 20,
              x: endPos.x,
              y: endPos.y,
              ease: "power1.out",
              onComplete: () => {
                coin.visible = false;
              },
            },
            "<"
          );
      }

      if (this._currentCoinGroup === 0) {
        this._currentCoinGroup = 1;
      } else {
        this._currentCoinGroup = 0;
      }
    }

    getPositionForPinkWinline(reel, row) {
      const container = this._reelPrizeObjects[reel][row].container;
      const width = this._redWinline.width / 2;
      const pos = { x: container.x - width, y: container.y - width };

      return pos;
    }

    playPinkWinline(posX, posY) {
      this._redWinline.x = posX;
      this._redWinline.y = posY;
      this._redWinline.visible = true;
      this._redWinline.gotoAndPlay(0);
    }

    collectPrize(objectToMove, reel, row, callback) {
      const symbolInfo = resourceManager.getConfiguration().symbols;
      const symbolId = this._currentBaseGameSymbols[reel][row];

      //I have no idea why this is happening and too busy to find out
      if (reel === 5 && row === 1) {
        objectToMove.x = 1105;
        objectToMove.y = 396;
      }

      const posX = objectToMove.x;
      const posY = objectToMove.y;

      const endPos = layoutController.getCurrentPosition(
        this._winningsPanel.Props.FQN
      );

      const speed = 3;
      const distanceX = Math.max(1, posX - endPos.x);
      const distanceY = Math.max(1, posY - endPos.y);
      const distance = distanceX + distanceY;
      const time = (1 + distance / 1000) / speed;

      if (symbolId === symbolInfo["Symbol_FireballX2"].ID) {
        soundManager.play("thunderballWinRed");

        const width = this._redWinline.width / 2;

        this.playPinkWinline(posX - width, posY - width);
      } else {
        if (symbolId >= 18) {
          let soundIndex = Math.floor(
            Math.random() * gameController.thunderballLandSound.length
          );
          soundManager.play(gameController.thunderballLandSound[soundIndex]);
        }

        objectToMove.visible = true;

        this._particleEmitter.particleEmitter.cleanup();
        this._particleEmitter.x = posX;
        this._particleEmitter.y = posY;
        this._particleEmitter.particleEmitter.emit = true;
        soundManager.play("coinSplash");
        this.animateCoins({ x: posX, y: posY }, endPos, time);
      }

      gsap
        .timeline()
        .to(objectToMove, {
          duration: 0.2,
          pixi: { scaleX: 1.3, scaleY: 1.3 },
          ease: "power1.out",
        })
        .to(objectToMove, {
          duration: 0.2,
          pixi: { scaleX: 1, scaleY: 1 },
          ease: "power1.in",
          onComplete: () => {
            objectToMove.visible = false;
            objectToMove.alpha = 1;
            callback();
          },
        });
    }

    toggleOverlay(show, reel, row) {
      this._stormLinkReels[reel][row].alpha = show ? 1 : 0;
      this._freeSpinsReels[reel][row].alpha = show ? 1 : 0;
    }

    setWinnings(newWinnings) {
      this._winnings = newWinnings;
    }

    countUpToNumber(total, callback, duration = 350) {
      const self = this;
      const start = this._winnings;
      const end = Math.min(total, this.getCurrentMaxWin());
      timerManager.addTimer(
        duration,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self._winningsText.setText(gdk.formatCurrency(val));

          let newScale = 1 + 0.25 * Math.abs(Math.sin(Math.PI * progress));
          self._winningsText.scale.set(newScale, newScale);
        },
        function () {
          self._winnings = end;
          self._winningsText.setText(gdk.formatCurrency(self._winnings));
          self._winningsText.scale.set(1, 1);
          if (end >= self.getCurrentMaxWin()) {
            self._maxWinBreached = true;
          }
          callback();
        }
      );
    }

    countUpPrize(newValue, callback, duration = 350) {
      const self = this;
      const start = this._winnings;
      const end = Math.min(start + newValue, this.getCurrentMaxWin());
      timerManager.addTimer(
        duration,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self._winningsText.setText(gdk.formatCurrency(val));

          let newScale = 1 + 0.25 * Math.abs(Math.sin(Math.PI * progress));
          self._winningsText.scale.set(newScale, newScale);
        },
        function () {
          self._winnings = end;
          self._winningsText.setText(gdk.formatCurrency(self._winnings));
          self._winningsText.scale.set(1, 1);
          if (end >= self.getCurrentMaxWin()) {
            self._maxWinBreached = true;
          }
          callback();
        }
      );
    }

    processMultipliers(callback) {
      if (this._skipped) {
        callback();
      } else {
        this._currentPrizeIndex = 0;
        this._countMultipliersStarted = 0;
        this.processNextMultiplier(callback);
      }
    }

    processNextMultiplier(callback) {
      if (this._multipliers.length === 0) {
        callback();
      } else {
        if (this._currentPrizeIndex < this._multipliers.length) {
          const self = this;
          ++this._countMultipliersStarted;
          this.processMultiplier(
            this._multipliers[this._currentPrizeIndex],
            function () {
              self._currentPrizeIndex++;

              if (self._countMultipliersStarted < self._multipliers.length) {
                timerManager.addTimeout(1000, function () {
                  self.processNextMultiplier(callback);
                });
              }

              if (self._currentPrizeIndex >= self._multipliers.length) {
                callback();
              }
            }
          );
        }
      }
    }

    processMultiplier(prize, callback) {
      const reel = prize.reel;
      const row = prize.row;

      const text = this._reelPrizeObjects[reel][row].text;
      text.setText("X" + prize.prizeData.value);
      text.visible = true;
      const container = this._reelPrizeObjects[reel][row].container;
      const self = this;

      this.toggleOverlay(false, reel, row);

      this.collectPrize(container, reel, row, function () {
        text.visible = false;
        self.toggleOverlay(true, reel, row);
        self.countUpPrize(
          self._winnings * prize.prizeData.value - self._winnings,
          function () {
            if (callback) {
              callback();
            }
          },
          1000
        );
      });
    }

    startShowPrizesFromExt(winnings) {
      this._winnings = winnings;
      this._winningsText.setText(gdk.formatCurrency(winnings));
    }

    showWinningsPanel(show, callback) {
      if (
        (show && !this._winningsPanel.visible) ||
        (!show && this._winningsPanel.visible)
      ) {
        if (show) {
          this._winningsPanel.visible = true;
          this._winningsPanel.alpha = 0;
        }
        const self = this;
        timerManager.addTimer(
          500,
          function (progress) {
            if (show) {
              self._winningsPanel.alpha = progress;
            } else {
              self._winningsPanel.alpha = 1 - progress;
            }
          },
          function () {
            self._winningsPanel.alpha = 1;
            if (!show) {
              self._winningsPanel.visible = false;
            }
            callback();
          }
        );
      } else {
        callback();
      }
    }

    onfireballLinkEndEvent(task) {
      task.join();
      this._endEvent = task;

      this._endTaskWinnings = task.data.winAmount;

      gameController.stormlinkWinnings = task.data.winAmount;

      this._megaPotWon = false;

      this._reelsTimer = undefined;

      messageBus.post("spinner:stormLinkEnd");

      this._winnings = 0;
      const self = this;
      this.showWinningsPanel(true, function () {
        self.processPrizes(function () {
          if (!self._maxWinBreached) {
            timerManager.addTimeout(800, function () {
              self.processMultipliers(function () {
                self.doBigWin();
              });
            });
          } else {
            self.doBigWin();
          }
        });
      });
    }

    doBigWin() {
      this.endFeature();
    }

    endFeature() {
      const self = this;

      this._fblLogo.visible = false;

      if (!this._inFS) {
        this._logo.visible = true;
        this._logo.alpha = 0;

        gsap.to(this._logo, {
          duration: 0.3,
          alpha: 1,
        });
      }

      gameController.stormLinkPayout = false;
      this._skipped = false;

      gameController.winningsContainer.visible = true;

      gameData.winningsMeter.add(this._endTaskWinnings);

      this._currentSpinPositions.forEach(function (position, id) {
        if (self._lockedReels.indexOf(id) === -1) {
          const reel = Math.floor(id / gameData.numRows);
          const row = id % gameData.numRows;
          gameData.reels[reel].setReelSymbol(row, position[0]);
        }
      });

      for (let reel = 0; reel < 6; ++reel) {
        gameData.reels[reel].redraw();
      }

      timerManager.addDelayedTimer(
        1000,
        500,
        function (progress) {
          self._winningsPanel.alpha = 1 - progress;
        },
        function () {
          self._winningsPanel.alpha = 1;
          self._winningsPanel.visible = false;

          resourceManager.get("slotContainer:reelContainer").visible = true;

          self._18timeslogo.visible = false;

          //this._winlinesTab.visible = true;

          self._fireslotsManager.visible = true;
          self._fireslotsManager.setx2PanelAlpha(1);

          // maybe not if in freespins or if we have a pot bonus
          if (
            gameController.inFreeSpins === false &&
            gameController.isPotBonus === null
          ) {
            self._linkBG.visible = false;
            self._linkBGPortrait.visible = false;
          } else {
            self._volcanoPot.visible = true;
          }

          gameData.reels.forEach(function (reel) {
            reel.lockFireballCashValues(true);
          });
          gameController.buyABonusFireball = false;

          self._slotMachine.clearDimSymbolIds();

          self.visible = false;
          self._endEvent.leave();
          self._endEvent = undefined;
          self._active = false;
        }
      );
    }

    onFreespinsStart() {
      this._inFS = true;
    }

    onFreespinsEndEvent() {
      this._inFS = false;
    }

    skip() {
      this._skipped = true;
    }
  }

  var firelinkFeatureCreator = function (json) {
    return new FirelinkFeature();
  };

  var firelinkFeatureInitialiser = function (json, firelinkFeature) {};

  var firelinkFeatureFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "firelinkFeature",
    firelinkFeatureCreator,
    firelinkFeatureInitialiser,
    firelinkFeatureFilesRequired
  );
})();
